import { Component, ChangeDetectionStrategy, inject, OnInit, PLATFORM_ID, signal } from '@angular/core';
import { isPlatformBrowser } from '@angular/common';

@Component({
  selector: 'app-ios-install-banner',
  changeDetection: ChangeDetectionStrategy.OnPush,
  template: `
    @if (showBanner()) {
      <div class="fixed bottom-0 inset-x-0 z-[997] animate-[slideUp_0.3s_ease-out]"
           role="dialog"
           aria-label="Instalare aplicatie">
        <div class="mx-auto max-w-2xl px-4 pb-4">
          <div class="bg-white dark:bg-gray-900 border border-gray-200 dark:border-gray-800
                      rounded-xl shadow-2xl p-4">
            <div class="flex items-start gap-3">
              <svg class="h-8 w-8 shrink-0 text-primary-600 dark:text-primary-400 mt-0.5" fill="none" viewBox="0 0 24 24" stroke-width="1.5" stroke="currentColor">
                <path stroke-linecap="round" stroke-linejoin="round" d="M10.5 1.5H8.25A2.25 2.25 0 0 0 6 3.75v16.5a2.25 2.25 0 0 0 2.25 2.25h7.5A2.25 2.25 0 0 0 18 20.25V3.75a2.25 2.25 0 0 0-2.25-2.25H13.5m-3 0V3h3V1.5m-3 0h3m-3 18.75h3" />
              </svg>
              <div class="flex-1 min-w-0">
                <p class="text-sm font-semibold text-gray-900 dark:text-white">
                  Instaleaza DateFirma
                </p>
                <p class="text-xs text-gray-500 dark:text-gray-400 mt-0.5">
                  Apasa pe
                  <svg class="inline-block h-4 w-4 align-text-bottom text-primary-600 dark:text-primary-400" fill="none" viewBox="0 0 24 24" stroke-width="1.5" stroke="currentColor">
                    <path stroke-linecap="round" stroke-linejoin="round" d="M9 8.25H7.5a2.25 2.25 0 0 0-2.25 2.25v9a2.25 2.25 0 0 0 2.25 2.25h9a2.25 2.25 0 0 0 2.25-2.25v-9a2.25 2.25 0 0 0-2.25-2.25H15m0-3-3-3m0 0-3 3m3-3V15" />
                  </svg>
                  apoi „Adauga pe ecranul principal".
                </p>
              </div>
              <button (click)="dismiss()"
                      class="p-1.5 text-gray-400 hover:text-gray-600 dark:hover:text-gray-300 rounded-lg
                             hover:bg-gray-100 dark:hover:bg-gray-800 transition-colors shrink-0"
                      aria-label="Inchide">
                <svg class="h-5 w-5" fill="none" viewBox="0 0 24 24" stroke-width="1.5" stroke="currentColor">
                  <path stroke-linecap="round" stroke-linejoin="round" d="M6 18 18 6M6 6l12 12" />
                </svg>
              </button>
            </div>
          </div>
        </div>
      </div>
    }
  `,
  styles: `
    @keyframes slideUp {
      from { transform: translateY(100%); opacity: 0; }
      to { transform: translateY(0); opacity: 1; }
    }
  `,
})
export class IosInstallBannerComponent implements OnInit {
  private readonly platformId = inject(PLATFORM_ID);
  protected readonly showBanner = signal(false);

  private static readonly STORAGE_KEY = 'ios-install-dismissed';

  ngOnInit(): void {
    if (!isPlatformBrowser(this.platformId)) return;

    const isIos = /iphone|ipad|ipod/i.test(navigator.userAgent);
    const isStandalone = 'standalone' in navigator && (navigator as unknown as { standalone: boolean }).standalone;
    const isDismissed = localStorage.getItem(IosInstallBannerComponent.STORAGE_KEY);

    this.showBanner.set(isIos && !isStandalone && !isDismissed);
  }

  protected dismiss(): void {
    localStorage.setItem(IosInstallBannerComponent.STORAGE_KEY, '1');
    this.showBanner.set(false);
  }
}
